import { DateCell, TimeCell } from 'components/DataTableTest'

const columns = (t, locales, listCashRegisters) => [{
	caption: t('common.fields.date'),
	dataField: 'time',
	width: 200,
	cellRender: DateCell({ locales })
}, {
	caption: t('common.fields.time'),
	dataField: 'time',
	width: 200,
	cellRender: TimeCell({ locales })
}, {
	caption: t('statistic_section.employeesData.action'),
	dataField: 'actionId',
	width: 200,
	cellRender: ({ value }) => {
		switch(value) {
			case '1': // STARTED
				return t('statistic_section.employeesData.start')
			case '21': // PAUSED
				return t('statistic_section.employeesData.pauseStart')
			case '11': // PAUSE END
				return t('statistic_section.employeesData.pauseEnd')
			case '2': // STOPED
				return t('statistic_section.employeesData.end')
			default:
				return ''
		}
	}
}, {
	caption: t('statistic_section.strings.user_name'),
	dataField: 'userName'
}, {
	caption: t('common.strings.branch'),
	dataField: 'cashRegisterId',
	cellRender: ({ value }) => listCashRegisters.find(cr => cr.id === value)?.shop?.name
}, {
	caption: t('options_section.strings.cash_register'),
	dataField: 'name'
}]

export default columns
